import React from 'react';


const TandC = () => {
  // const [accepted, setAccepted] = useState(false);

  return (
    <div className=" py-16 sm:px-6 lg:px-8">
      <div className="bg-gray-200 shadow-lg rounded-lg overflow-hidden">
        <div className="p-6 sm:p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms and Conditions</h1>
            <p className="text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          {/* Scrollable Content */}
          <div className="min-h-screen  mb-8 p-4 border border-gray-200 rounded-lg">
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">1. Acceptance of Terms</h2>
                <p className="text-gray-700 leading-relaxed">
                  By accessing and using this website/application, you accept and agree to be bound by the terms 
                  and provision of this agreement. If you do not agree to abide by these terms, please do not use this service.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">2. Use License</h2>
                <p className="text-gray-700 leading-relaxed">
                  Permission is granted to temporarily use the materials on our website for personal, 
                  non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">3. User Account</h2>
                <p className="text-gray-700 leading-relaxed">
                  When you create an account with us, you must provide accurate and complete information. 
                  You are responsible for safeguarding your password and for all activities that occur under your account.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">4. Privacy Policy</h2>
                <p className="text-gray-700 leading-relaxed">
                  Your privacy is important to us. Please review our Privacy Policy, which explains how we collect, 
                  use, and protect your personal information.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">5. Intellectual Property</h2>
                <p className="text-gray-700 leading-relaxed">
                  All content included on this site, such as text, graphics, logos, images, and software, 
                  is the property of the company or its content suppliers and protected by international copyright laws.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">6. Prohibited Uses</h2>
                <p className="text-gray-700 leading-relaxed mb-3">You may not use our service:</p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>For any unlawful purpose or to solicit others to perform illegal acts</li>
                  <li>To violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances</li>
                  <li>To infringe upon or violate our intellectual property rights or the intellectual property rights of others</li>
                  <li>To harass, abuse, insult, harm, defame, slander, or intimidate others</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">7. Termination</h2>
                <p className="text-gray-700 leading-relaxed">
                  We may terminate or suspend your account and bar access to the service immediately, without prior notice 
                  or liability, under our sole discretion, for any reason whatsoever, including but not limited to a breach of the Terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">8. Limitation of Liability</h2>
                <p className="text-gray-700 leading-relaxed">
                  In no event shall the company, nor its directors, employees, partners, agents, suppliers, or affiliates, 
                  be liable for any indirect, incidental, special, consequential or punitive damages resulting from your use of our services.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">9. Governing Law</h2>
                <p className="text-gray-700 leading-relaxed">
                  These Terms shall be governed and construed in accordance with the laws of [Your Country/State], 
                  without regard to its conflict of law provisions.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">10. Changes to Terms</h2>
                <p className="text-gray-700 leading-relaxed">
                  We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
                  By continuing to access or use our service after those revisions become effective, you agree to be bound by the revised terms.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-blue-600 mb-3">11. Contact Information</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions about these Terms and Conditions, please contact us at:{' '}
                  <a href="mailto:legal@yourcompany.com" className="text-blue-600 hover:text-blue-800 underline">
                    legal@yourcompany.com
                  </a>
                </p>
              </section>
            </div>
          </div>

          {/* Acceptance Section */}
          {/* <div className="bg-gray-50 p-6 rounded-lg border border-gray-200">
            <div className="flex items-center mb-4">
              <input
                type="checkbox"
                id="accept-terms"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                className="h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
              />
              <label htmlFor="accept-terms" className="ml-3 text-gray-700 font-medium">
                I have read and agree to the Terms and Conditions
              </label>
            </div>
            
            <button
              className={`w-full py-3 px-4 rounded-md font-medium transition-colors duration-200 ${
                accepted
                  ? 'bg-blue-600 hover:bg-blue-700 text-white cursor-pointer'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
              disabled={!accepted}
            >
              Accept and Continue
            </button>
          </div> */}

          {/* Footer Note */}
          <div className="mt-4 text-center">
            <p className="text-sm text-gray-500">
              By clicking "Accept and Continue", you acknowledge that you have read and understood our Terms and Conditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TandC;